module.exports = __webpack_public_path__ + "img/sepa.769561d7.svg";